"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchTile = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Theme_1 = require("@amzn/atoz-web/Theme");
const IconButtonWithModal_1 = require("../IconButtonWithModal");
const usePunchTile_1 = require("./usePunchTile");
const PunchDetailsModal_web_1 = require("../PunchDetailsModal/PunchDetailsModal.web");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
const PunchTile = ({ type, time, selectedDate, militaryTime, timeDeletable, isClickable = false, isInProgress = false, isPunchEditable = false, punchDetails, renderPunchDeletionConfirmationModal, renderPunchEditModal, renderMissedPunchModalContent, useUnifiedPunchesAPIForWeb = false, isMissedPunchClickableRowForWebEnabled = false, isDeleteAIPPunch, readOnly = false }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { missed, title, year, month, day, timeString, ariaLabel, timeDT } = (0, usePunchTile_1.usePunchTile)({
        time,
        militaryTime,
        type,
        selectedDate,
        isMissedPunchClickableRowEnabled: isMissedPunchClickableRowForWebEnabled
    });
    const enableMissedPunchModal = !readOnly && isMissedPunchClickableRowForWebEnabled && missed;
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const closePunchDetailsModal = () => {
        setIsOpen(false);
    };
    const openPunchDetailsModal = (shouldOpen) => {
        if (readOnly) {
            return;
        }
        setIsOpen(shouldOpen);
    };
    const punchDetailModalTitle = t('time_and_attendance_PunchDetailsModal_PunchType', {
        punchType: type
    });
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    (0, react_1.useEffect)(() => {
        if (isOpen && enableMissedPunchModal) {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.MISSED_PUNCH_MODAL_FROM_CLICKABLE_ROW.COUNT,
                dimensions
            });
        }
    }, [isOpen, enableMissedPunchModal]);
    const renderPunchDetailsModal = () => (react_1.default.createElement(Modal_1.Modal, { isOpen: isOpen, close: closePunchDetailsModal },
        react_1.default.createElement(PunchDetailsModal_web_1.PunchDetailsModal, { title: punchDetailModalTitle, timestampString: `${month} ${day}, ${year} at ${timeString}`, punchDetails: punchDetails, punchDateTime: timeDT, closeModal: closePunchDetailsModal, isInProgress: isInProgress, isPunchEditable: isPunchEditable, isPunchDeletable: timeDeletable, renderPunchDeletionConfirmationModal: renderPunchDeletionConfirmationModal, renderPunchEditModal: renderPunchEditModal, isDeleteAIPPunch: isDeleteAIPPunch })));
    const renderMissedPunchModal = () => (react_1.default.createElement(Modal_1.Modal, { isOpen: isOpen, close: closePunchDetailsModal }, renderMissedPunchModalContent === null || renderMissedPunchModalContent === void 0 ? void 0 : renderMissedPunchModalContent({ close: closePunchDetailsModal })));
    const renderActions = () => {
        if (timeDeletable && renderPunchDeletionConfirmationModal) {
            return (react_1.default.createElement(IconButtonWithModal_1.IconButtonWithModal, { dataTestId: "DeleteButtonWithModal", renderModal: renderPunchDeletionConfirmationModal, renderModalArgs: [timeDT], ariaLabel: t('time_and_attendance_PunchDeletionConfirmationModal_DeleteButton_ariaLabel'), icon: react_1.default.createElement(Icons_1.IconBin, { title: t(`time_and_attendance_Delete_Ashcan_img_alt`), color: "red80", size: Icons_1.IconSize.ExtraSmall, dataTestId: "delete-punch-icon" }) }));
        }
        else if (isInProgress) {
            return (react_1.default.createElement(IconButton, { "aria-label": t('time_and_attendance_PunchEditInProgressModal_InfoIcon_ariaLabel'), onClick: () => {
                    openPunchDetailsModal(isInProgress);
                }, disabled: !punchDetails, "data-test-id": "punch-in-progress-info-btn" },
                react_1.default.createElement(Icons_1.IconInformationFill, { title: t(`time_and_attendance_Information_Icon_img_alt`), color: "primary70", size: Icons_1.IconSize.Medium })));
        }
        else if (enableMissedPunchModal) {
            return (react_1.default.createElement(IconButton, { onClick: () => {
                    openPunchDetailsModal(true);
                }, "data-test-id": "missed-punch-icon" },
                react_1.default.createElement(Icons_1.IconPlusCircle, { title: t('time_and_attendance_PunchTile_AddMissedPunch_Icon_ImgAlt'), color: "primary70", size: Icons_1.IconSize.Medium })));
        }
    };
    const renderPunchTileContent = () => (react_1.default.createElement(PunchTileContent, null,
        react_1.default.createElement(Col_1.Col, null,
            react_1.default.createElement(Text_1.Text, { color: missed ? 'red70' : 'neutral90', fontSize: "T200", fontWeight: "bold", textAlign: "left" }, title),
            react_1.default.createElement(Text_1.Text, { color: "neutral70", fontSize: "T100", textAlign: "left" }, `${month} ${day}`)),
        isClickable ? (react_1.default.createElement(PunchTimeButton, { "data-test-id": "PunchTimeText", onClick: () => {
                openPunchDetailsModal(isClickable);
            } },
            react_1.default.createElement(Text_1.Text, { fontSize: "T400", fontWeight: "bold", color: missed ? 'red70' : isInProgress ? 'neutral50' : 'neutral90' }, timeString))) : (react_1.default.createElement(PunchTimeText, { dataTestId: "PunchTimeText", fontSize: "T400", fontWeight: "bold", color: missed ? 'red70' : isInProgress ? 'neutral50' : 'neutral90' }, timeString)),
        !readOnly && (react_1.default.createElement(Row_1.Row, { justifyContent: "end", flex: "0 1 16%" }, renderActions()))));
    const renderPunchTileContentV2 = () => (react_1.default.createElement(PunchTileContent, { dataTestId: "V2PunchTileContent", isClickable: isClickable || enableMissedPunchModal, onClick: () => {
            openPunchDetailsModal((isClickable && !!punchDetails) || enableMissedPunchModal);
        }, onKeyDown: ({ key }) => {
            if (key === 'Enter') {
                openPunchDetailsModal((isClickable && !!punchDetails) || enableMissedPunchModal);
            }
        }, tabIndex: 0, role: isClickable || enableMissedPunchModal ? 'button' : 'none' },
        react_1.default.createElement(Col_1.Col, null,
            react_1.default.createElement(Text_1.Text, { color: missed ? 'red70' : 'neutral90', fontSize: "T200", fontWeight: "bold", textAlign: "left" }, title),
            react_1.default.createElement(Text_1.Text, { color: "neutral70", fontSize: "T100", textAlign: "left" }, `${month} ${day}`)),
        react_1.default.createElement(PunchTimeText, { dataTestId: "PunchTimeText", fontSize: "T400", fontWeight: "bold", color: missed ? 'red70' : isInProgress ? 'neutral50' : 'neutral90' }, timeString),
        !readOnly && (react_1.default.createElement(Row_1.Row, { justifyContent: "end", flex: "0 1 16%" },
            isClickable &&
                (isInProgress ? (react_1.default.createElement(Icons_1.IconInformationFill, { title: t(`time_and_attendance_Information_Icon_img_alt`), color: "primary70", size: Icons_1.IconSize.Medium, dataTestId: "PunchInProgressIcon" })) : (react_1.default.createElement(Icons_1.IconPencil, { title: t(`time_and_attendance_PunchEdit_Icon_img_alt`), color: "primary70", size: Icons_1.IconSize.Medium, dataTestId: "PunchEditIcon" }))),
            enableMissedPunchModal && (react_1.default.createElement(Icons_1.IconPlusCircle, { title: t('time_and_attendance_PunchTile_AddMissedPunch_Icon_ImgAlt'), color: "primary70", size: Icons_1.IconSize.Medium, dataTestId: "missedPunchIcon" }))))));
    return (react_1.default.createElement(PunchTileContainer, { dataTestId: "PunchTile", "aria-label": ariaLabel },
        useUnifiedPunchesAPIForWeb
            ? renderPunchTileContentV2()
            : renderPunchTileContent(),
        enableMissedPunchModal
            ? renderMissedPunchModal()
            : renderPunchDetailsModal()));
};
exports.PunchTile = PunchTile;
const PunchTileContainer = (0, Theme_1.styledWithTheme)(Row_1.Row)(({ theme }) => `
    align-items: center;
    position: relative;
    padding-left: 10%;

    &:before {
      content: '';
      background-color: ${theme.selectors.color('primary70')};
      width: 2px;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 4px;
    }

    &:after {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 2px solid ${theme.selectors.color('primary70')};
      position: absolute;
      left: 1px;
      top: 16px;
      box-sizing: border-box;

    }

    &:nth-of-type(odd):after {
      background-color: ${theme.selectors.color('primary70')};
    }

    &:nth-of-type(even):after {
      background-color: ${theme.selectors.color('neutral0')};
    }

    &:first-of-type:before {
      height: calc(100% - 16px);
    }

    &:last-of-type:before {
      height: 16px;
      top: 0;
      bottom: unset;
    }

    &:not(:last-of-type) > div {
      border-bottom: 1px dashed ${theme.selectors.color('neutral05')};
    }
  `);
const PunchTileContent = (0, Theme_1.styledWithTheme)(Row_1.Row)(({ isClickable }) => `
    flex: 1 1 auto;
    align-items: center;
    padding: 8px 0;
    cursor: ${isClickable ? 'pointer' : 'auto'};
  `);
const PunchTimeText = (0, Theme_1.styledWithTheme)(Text_1.Text)(`
    text-align: right;
    flex: 1 0 auto;
  `);
const PunchTimeButton = (0, Theme_1.styledWithTheme)('button')(`
    padding: 0;
    background-color: transparent;
    border: none;
    text-align: right;
    flex: 1 0 auto;

    &:hover {
      cursor: pointer;
    }

    &:focus-visible {
      text-decoration: underline;
    }
  `);
const IconButton = (0, Theme_1.styledWithTheme)('button')(({ theme }) => `
    background-color: transparent;
    border: none;
    border-radius: 2px;
    padding: 0;

    &:hover {
      cursor: pointer;
      &:disabled {
        cursor: default;
      }
    }

    &:focus-visible {
      outline: 2px solid ${theme.selectors.color('primary70')};
    }
  `);
